import React, { useState, useEffect } from "react"
import { render } from "react-dom"
import { createStore, applyMiddleware } from "redux"
import { connect, Provider } from "react-redux"

import CustomAudioPlayer from "components/CustomAudioPlayer"
import CheckoutCart from "components/CheckoutCart"

import rootReducer from "reducers"
import thunk from "redux-thunk"
import axios from "axios"
import { fetchAllCartItems, fetchAllUpsells } from "actions/index"

const store = createStore(rootReducer, applyMiddleware(thunk))

store.dispatch(fetchAllCartItems());
store.dispatch(fetchAllUpsells());

class Checkout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHighResLoaded: false
    };
  }

  componentDidMount() {
    // Load high-res image after component mounts
    if (this.props.checkoutImage) {
      const img = new Image();
      img.src = this.props.checkoutImage;
      img.onload = () => {
        this.setState({ isHighResLoaded: true });
      };
    }
  }

  render() {
    return (
      <Provider store={store}>
        <CheckoutCart
          userSignedIn={this.props.userSignedIn}
          stripeKey={this.props.stripeKey}
          checkoutImage={this.props.checkoutImage}
          isHighResLoaded={this.state.isHighResLoaded}
          userEmail={this.props.userEmail}
          authenticityToken={this.props.authenticityToken}
          serumOrSerumPresets={this.props.serumOrSerumPresets}
          userId={this.props.userId}
          paypalClientId={this.props.paypalClientId}
          ownedProductIds={this.props.ownedProductIds}
        />

        <CustomAudioPlayer hideWhenEmpty={true} />
      </Provider>
    )
  }
}

export default Checkout;
